var map = {
	"./Adriel.jpeg": 5428,
	"./Fede.jpg": 9716,
	"./Gus.jpeg": 8752,
	"./Juan.jpeg": 1453,
	"./Mati.jpeg": 4261,
	"./Pablo.jpg": 1624,
	"./Pedro.jpeg": 7866,
	"./prueba.jpeg": 6071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8755;